/**
 * Control the conversion from mobile accordion menu
 * Includes an automatic resize between mobile and desktop
 * @author Jess McClary <jess.mcclary@tricomb2b.com>
 * @author Todd Miller <github.com/Toddses>
 */
import debounce from 'debounce';

(function ($) {
  'use strict';

  let $menus;

  Drupal.behaviors.initializeFooterMenus = {
    attach: (context) => {
      if (context === document) {
        initialize();
      }
    },
  };

  /**
   * Open or close the given sub menu.
   */
  function handleClick(e) {
    const $target = $(e.currentTarget);

    if ($target.parent().hasClass('has-children')) {
      e.preventDefault();
      e.stopPropagation();

      $('+ ul.sub-menu', $target).slideToggle(200, () => {
        $target.parent().toggleClass('open');
      });
    }
  }

  /**
   * Cache and set up elements, attach resize handler.
   */
  function initialize() {
    $menus = $('#block-footermain ul li > a');
    if (!$menus.length) return;

    $('#block-footer-mainnavigation > ul > li').each((index, element) => {
      $(element).addClass('top-level');
    });

    const $children = $('#block-footer-mainnavigation .top-level > ul');
    $children.parent().addClass('has-children');
    $children.addClass('sub-menu');

    $menus.each(function (index, menu) {
      const $li = $('<li class="overview"></li>').append(
        $(menu).clone().text('Overview')
      );
      $('+ ul', $(menu)).prepend($li);
    });

    setHandlers();
    window.addEventListener('resize', debounce(setHandlers));
  }

  /**
   * Attach and detach click handlers, depending on whether the user
   * is on mobile widths.
   */
  function setHandlers() {
    $menus.off('click', handleClick);

    if (window.matchMedia('(max-width: 1024px)').matches)
      $menus.on('click', handleClick);
  }
})(jQuery);
